<template>
  <div
    v-if="label"
    class="text-global-notice md:container"
    style="
      font-family: var(--preferred-font-global-notice);
      font-size: var(--preferred-font-size-global-notice);
    "
  >
    <div class="bg-global-notice-bg md:container">
      <div
        v-if="isActive"
        class="bg-global-notice-bg md:flex md:items-center md:justify-center"
      >
        <div class="flex flex-wrap justify-center py-2 text-center">
          <span class="font-semibold">{{ label }}</span>

          <span class="flex items-center justify-center font-semibold">
            <ClockIcon class="h-5 w-auto px-2" />
            <span>{{ days }}&nbsp;</span>
            <span>{{ hours }}</span
            >:<span>{{ minutes }}</span
            >:<span>{{ seconds }}</span>
          </span>
        </div>
      </div>
      <div v-else class="py-2 text-center">
        <span class="font-semibold">
          {{ labelExpired }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, Ref, ref } from 'vue';
import ClockIcon from '@/components/Icons/ClockIcon.vue';
import I18n from '@/i18n.ts';

const startDate: Ref<string | undefined> = ref(
  window.timer ? window.timer?.start_date : undefined
);

const endDate: Ref<string | undefined> = ref(
  window.timer ? window.timer?.end_date : undefined
);

const label: Ref<string | undefined> = ref(
  window.timer ? window.timer?.label : undefined
);

const labelExpired: Ref<string | undefined> = ref(
  window.timer ? window.timer?.expired_label : undefined
);

const isActive = ref<boolean>(false);
const days = ref<string>('');
const hours = ref<string>('');
const minutes = ref<string>('');
const seconds = ref<string>('');

const runTimer = () => {
  // Timer not started yet
  if (
    startDate.value &&
    new Date(Date.parse(startDate.value)).getTime() > new Date().getTime()
  ) {
    isActive.value = false;
    return;
  }

  // Timer expired
  if (
    endDate.value === undefined ||
    new Date(Date.parse(endDate.value)).getTime() <= new Date().getTime()
  ) {
    isActive.value = false;
    return;
  }

  isActive.value = true;

  const difference =
    new Date(Date.parse(endDate.value)).getTime() - new Date().getTime();

  const s = Math.floor(difference / 1000) % 60;
  const m = Math.floor(difference / 1000 / 60) % 60;
  const h = Math.floor(difference / 1000 / 60 / 60) % 24;
  const d = Math.floor(difference / 1000 / 60 / 60 / 24);

  days.value =
    d +
    ' ' +
    (d === 1
      ? I18n.global.t('pages.product_detail_page.timer.day').toLowerCase()
      : I18n.global.t('pages.product_detail_page.timer.days').toLowerCase());
  hours.value = ('0' + h).slice(-2);
  minutes.value = ('0' + m).slice(-2);
  seconds.value = ('0' + s).slice(-2);
};

const timerInterval: Ref<NodeJS.Timeout | undefined> = ref(undefined);
onMounted(() => {
  runTimer();
  if (isActive.value) timerInterval.value = setInterval(runTimer, 1000);
});

onUnmounted(() => {
  clearInterval(timerInterval.value);
});
</script>
